module.exports = __webpack_public_path__ + "img/jp.a320da25.png";